import { ShippingConfigType } from '../../../_models/shipping-config.interface';

/**
 * Die „Positionen" des geführten Versandziel-Dialogs: pro Versandtyp die Liste
 * der Angaben, die ausgefüllt sein müssen. Reihenfolge = Anzeige-Reihenfolge;
 * bearbeitet werden darf jede Position jederzeit (kein Durchklick-Zwang).
 */
export type PositionId =
  | 'station'
  | 'method'
  | 'technician'
  | 'pm_code'
  | 'disposition'
  | 'ship_address'
  | 'customer';

export interface PositionMeta {
  /** Überschrift der Position. */
  title: string;
  /** Erklärt in einem Satz, was hier entschieden wird. */
  hint: string;
}

export const POSITIONS_BY_TYPE: Record<ShippingConfigType, PositionId[]> = {
  pickpoint: ['station', 'method', 'technician', 'pm_code'],
  store_shipping: ['method', 'disposition'],
  technician_shipping: ['technician', 'method', 'ship_address'],
  customer_shipping: ['customer', 'method'],
};

export const POSITION_META: Record<PositionId, PositionMeta> = {
  station: {
    title: 'Station auswählen',
    hint: 'An diese PickPoint-Station geht das Paket. Die Auswahl über die Karte zeigt die Stationen in der Nähe des Auftragsorts.',
  },
  method: {
    title: 'Versandart',
    hint: 'Wie das Material transportiert wird. Bei Paketversand zusätzlich, wie schnell es gehen soll.',
  },
  technician: {
    title: 'Ziel-Techniker',
    hint: 'Auf wen das Material nach Versand umgebucht wird.',
  },
  pm_code: {
    title: 'Abholcode',
    hint: 'Der PM-Code kommt aufs Zusatz-Etikett. Die Station prüft damit, wer das Paket abholen darf.',
  },
  disposition: {
    title: 'Artikelumbuchung',
    hint: 'Was mit den Artikeln passiert, sobald das Paket rausgeht: auf einen Techniker umbuchen oder direkt als verbraucht verbuchen.',
  },
  ship_address: {
    title: 'Versandadresse',
    hint: 'Wohin die LagerApp den Technikerversand schickt. Der Lagerist kann das dort nicht mehr ändern.',
  },
  customer: {
    title: 'Ziel-Kunde',
    hint: 'An diese Rücksendeadresse geht das Material zurück. Ohne hinterlegte Adresse kann das Lager nicht versenden.',
  },
};
